var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-card',[_c('v-card-text',[_vm._t("header"),_c('GChart',{attrs:{"type":"PieChart","data":_vm.chartData,"options":_vm.chartOptions}})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }